import { ProductParagraph, Spacing } from '@issuu/silkscreen';
import React from 'react';
const Byline = props => (React.createElement(Spacing, { bottom: 2, top: 2 },
    React.createElement(ProductParagraph, null, props.children)));
export default Byline;
//# sourceMappingURL=Byline.js.map